import {Axios} from "./Axios";

/**
 * 설문조사 리스트 조회 API
 * @param params : 파라미터
 * @returns {Promise<unknown>}
 */
async function fetchSurveyList(params) {
  return await Axios.get('/surveys', params);
}

/**
 * 설문조사 조회 API
 * @param surveyId : 설문조사 ID
 * @returns {Promise<unknown>}
 */
async function fetchSelectSurvey(surveyId) {
  return await Axios.get(`/surveys/${surveyId}`);
}

/**
 * 설문조사 답변 가능 여부 확인 API
 * @param surveyMemberId : 설문조사 대상 ID
 * @returns {Promise<unknown>}
 */
async function fetchValidateSurvey(surveyMemberId) {
  return await Axios.get(`/surveys/members/${surveyMemberId}/validate`);
}

/**
 * 설문조사 질문 리스트 조회 API
 * @param surveyId : 설문조사 ID
 * @returns {Promise<unknown>}
 */
async function fetchSurveyQuestions(surveyId) {
  return await Axios.get(`/surveys/${surveyId}/questions`);
}

/**
 * 설문조사 회원 답변 생성 API
 * @param surveyMemberId : 설문조사 대상 ID
 * @param data : 데이터
 * @returns {Promise<unknown>}
 */
async function createSurveyMemberAnswer(surveyMemberId, data) {
  return await Axios.post(`/surveys/members/${surveyMemberId}/answers`, data);
}

/**
 * POS 주문 조회
 * @param params : 파라미터
 * @returns {Promise<unknown>}
 */
async function searchPosOrders(params) {
  return await Axios.get(`/posorders`, params);
}

/**
 * POS 전자영수증 조회
 * @param posOrderId : POS 주문 ID
 * @returns {Promise<unknown>}
 */
async function findPosOrderReceipts(posOrderId) {
  return await Axios.get(`/posorders/${posOrderId}/receipts`);
}


/**
 * 설문조사 가능 여부 및 참여 여부 조회
 * @param orderNo : 주문번호
 * @returns {Promise<unknown>}
 */
async function searchSurveyMembers(orderNo) {
  return await Axios.get(`/guests/surveys/members`,{orderNo:orderNo});
}

/**
 * 설문조사 비회원 답변 가능 여부 확인 API
 * @param surveyMemberId : 설문조사 대상ID
 * @returns {Promise<unknown>}
 */
async function validateSurvey(surveyMemberId) {
  return await Axios.get(`/guests/surveys/members/${surveyMemberId}/validate`);
}

/**
 * 설문조사 비회원 답변 생성 API
 * @param surveyMemberId : 설문조사 대상ID
 * @param data : 데이터
 * @returns {Promise<unknown>}
 */
async function createSurveyAnswer(surveyMemberId, data) {
  return await Axios.post(`/guests/surveys/members/${surveyMemberId}/answers`, data);
}

export {
  fetchSurveyList,
  fetchSelectSurvey,
  fetchValidateSurvey,
  fetchSurveyQuestions,
  createSurveyMemberAnswer,
  findPosOrderReceipts,
  searchPosOrders,
  searchSurveyMembers,
  validateSurvey,
  createSurveyAnswer
}



// WEBPACK FOOTER //
// ./src/api/index.js